import { render, staticRenderFns } from "./VkSelect.vue?vue&type=template&id=1ade885b&"
import script from "./VkSelect.vue?vue&type=script&lang=ts&"
export * from "./VkSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports